<template>
    <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
        <!--begin::Toolbar-->
        <div class="toolbar" id="kt_toolbar">
            <!--begin::Container-->
            <app-sub-header :title="title" :breadcrumbs="breadcrumbs" :back="false"></app-sub-header>
            <!--end::Container-->
        </div>
        <!-- Loader -->
        <div class="container-xxl" v-show="!isReady">
            <Loader />
        </div>
        <!--begin::Post-->
        <div v-show="isReady">
            <div class="post d-flex flex-column-fluid" id="kt_post">
                <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
                    <div class="card">
                        <div class="card-header flex-wrap border-0 pt-6 pb-0">
                            <div class="card-title">
                                <h3 class="card-label">{{ $t('purchase.list') }}</h3>
                            </div>
                            <div class="card-toolbar">
                                <router-link :to="{ name: 'suppliers-purchases-create' }"
                                    class="btn btn-sm btn-primary">{{ $t('purchase.create') }}</router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="d-flex align-items-center justify-content-end">
                                    <div suppliers-purchases-daterangepicker="true" data-kt-daterangepicker-opens="left"
                                        class="btn btn-sm btn-light d-flex align-items-center px-4 border border-primary">
                                        <div class="text-gray-600 fw-bolder">{{ $t('dashboard.loading') }}...</div>
                                        <span class="svg-icon svg-icon-1 ms-2 me-0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path opacity="0.3"
                                                    d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z"
                                                    fill="currentColor" />
                                                <path
                                                    d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z"
                                                    fill="currentColor" />
                                                <path
                                                    d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z"
                                                    fill="currentColor" />
                                            </svg>
                                        </span>
                                    </div>
                                    <Select2 container-class="w-200px mx-2" :multiple="false" :show-search="false"
                                        :selectClass="'form-select form-control-lg border border-primary'"
                                        name="order-status" v-model="query.status">
                                        <option key="all" value="all"> {{ $t('all') }} </option>
                                        <option v-for="(status, index) in orderStatus" :key="index"
                                            :value="status.value">
                                            {{ status[locale] }}
                                        </option>
                                    </Select2>
                                </div>
                                <table class="table align-middle table-row-bordered fs-6 gy-3 "
                                    id="kt_datatable_suppliers_purchase">
                                    <thead>
                                        <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                                            <th class="min-w-100px">{{ $t('purchase.number') }}</th>
                                            <th class="min-w-100px">{{ $t('purchase.supplier_name') }}</th>
                                            <th class="min-w-100px">{{ $t('purchase.date') }}</th>
                                            <th class="min-w-100px">{{ $t('purchase.delivery_date') }}</th>
                                            <th class="min-w-100px">{{ $t('purchase.status') }}</th>
                                            <th class="min-w-100px">{{ $t('action') }}</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script setup>

import AppSubHeader from "@/views/SupplierPurchase/Partials/AppSubHeader.vue";
import Loader from "@/components/Loader.vue";
import { BASE_URL, BASE_IMAGE_URL } from "@/services/api";
import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router"
import { useHasAbility } from "@/composables/hasAbility";
import Ls from "@/services/ls";
import { formatDate, createFormData } from "@/mixins/Helper.vue";
import Select2 from "@/components/Select2.vue";



const router = useRouter()
const store = useStore()
const { can } = useHasAbility()

const locale = computed(() => i18n.global.locale)
const getDatatableLocaleUrl = computed(() => {
    return locale.value === 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json"
})
const orderStatus = computed(() => store.getters['orders/getOrderStatus'])


const title = ref("breadcrumbs.purchase.title")
const breadcrumbs = ref([
    {
        name: 'breadcrumbs.purchase.list',
        path: '/admin/suppliers/purchases'
    }
])
const isReady = ref(false)
const table = ref()
const query = ref({
    status: 'all',
    date: '',
    delivery_date: '',
    supplier_name: ''
})
const formDeleteData = ref({
    id: null,
    row: null
})
const formCreateData = ref({
    title: '',
    image: '/assets/media/img_default.png',
    apply: ""
})

onMounted(() => {
    isReady.value = false
    store.dispatch('orders/loadOrderStatus')
    fetchSuppliersPurchases()
    initDateRange()
    isReady.value = true
    $(document).on("click", "#kt_datatable_suppliers_purchase .eye_btn", async (e) => {
        let id_order = e.target.getAttribute('data-id')
        if (id_order) {
            router.push({ name: 'suppliers-purchases-view', params: { id: id_order } })
        }
    });

    $(document).on("click", "#kt_datatable_suppliers_purchase .edit_btn", async (e) => {
        let id_order = e.target.getAttribute('data-id')
        if (id_order) {
            router.push({ name: 'suppliers-purchases-edit', params: { id: id_order } })
        }
    });
})

watch(() => query.value.status, (newValue) => {
    table.value.ajax.url(`${BASE_URL}/orders/datatables?status=${newValue}&date=${query.value.date}&delivery_date=${query.value.delivery_date}`).load()
})

watch(() => [query.value.date, query.value.delivery_date], (newValue) => {
    table.value.ajax.url(`${BASE_URL}/orders/datatables?status=${query.value.status}&date=${query.value.date}&delivery_date=${query.value.delivery_date}`).load()
})
    

async function initDateRange() {
      let element = document.querySelector('[suppliers-purchases-daterangepicker="true"]');
      let start = moment().subtract(29, 'days');
      let end = moment();

      let date = start.format('DD-MM-YYYY')
      let delivery_date = end.format('DD-MM-YYYY')

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        date: start,
        delivery_date: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'),i18n.global.t('lu'),i18n.global.t('ma'),i18n.global.t('me'),i18n.global.t('je'),i18n.global.t('ve'),i18n.global.t('sa')],
          monthNames: [i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'), i18n.global.t('april'), i18n.global.t('may'),
            i18n.global.t('june'), i18n.global.t('july'),  i18n.global.t('august'),  i18n.global.t('september'),  i18n.global.t('october'),  i18n.global.t('november'),  i18n.global.t('december')],
          firstDay: 1
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]

        }
      }, cb);

      cb(start, end);

    }

    async function cb(start, end) {
      let element = document.querySelector('[suppliers-purchases-daterangepicker="true"]');
      let display = element.querySelector('div');
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY');
      }
      query.value.date = start.format('DD-MM-YYYY')
      query.value.delivery_date = end.format('DD-MM-YYYY')

    }

function fetchSuppliersPurchases() {
    const AUTH_TOKEN = Ls.get('auth.token')

    table.value = $("#kt_datatable_suppliers_purchase").DataTable({
        destroy: true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        order: [[0, 'desc']],
        ajax: {
            url: BASE_URL + "/orders/datatables?date=" + query.value.date + "&delivery_date=" + query.value.delivery_date,
            type: "GET",
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
            }
        },
        columns: [
            { data: "number" },
            { data: "supplier_name" },
            { data: "date" },
            { data: "delivery_date" },
            { data: "status" },
            { data: "actions", responsivePriority: -1 }
        ],
        columnDefs: [

            {
                targets: -6,
                className: "dt-center clickable",
                render: (t, a, e, l) => {
                    return '<span data-id="' + e.id + '">' + t + "</span>";
                },
            },

            {
                targets: -5,
                className: "dt-center clickable text-center",
                render: function (t, a, e, l) {
                    return '<span data-id="' + e.id + '" >' + t + "</span>";
                },
            },

            {
                targets: -4,
                className: "dt-center clickable",
                render: function (t, a, e, l) {
                    return '<span data-id="' + e.id + '">' + formatDate(t) + "</span>";
                },
            },

            {
                targets: -3,
                className: "dt-center clickable",
                render: function (t, a, e, l) {
                    return '<span data-id="' + e.id + '">' + formatDate(t) + "</span>";
                },
            },

            {
                targets: -2,
                orderable: false,
                searchable: false,
                render: (t, a, e, l) => {
                    return '<span class="light-primary" data-id="' + e.id + '"> '+ e.status_format +'</span>'
                },
            },

            {
                width: "20%",
                targets: -1,
                "className": "dt-center",
                title: "Actions",
                orderable: !1,
                render: (t, a, e, l) => {
                    let render = ""
                    if(e.status == 'DRAFT') render += '<a href="javascript:;"  data-id="' + e.id + '" class="btn btn-sm btn-clean btn-icon edit_btn" title="' + i18n.global.t('button.edit') + '"><i  data-id="' + e.id + '"  class="la la-edit fs-2"></i></a>'
                    else render += '<a href="javascript:;"  data-id="' + e.id + '" class="btn btn-sm btn-clean btn-icon">...</a>'
                    render += '<a href="javascript:;" data-row="' + l.row + '" data-id="' + e.id + '" class="btn btn-sm btn-clean btn-icon eye_btn" title="' + i18n.global.t('button.show') + '"><i data-row="' + l.row + '" data-id="' + e.id + '" class="fa fa-eye fs-2"></i></a>'
                    return render
                },
            },
        ],
        language: {
            url: getDatatableLocaleUrl.value,
        }
    });

    $(document).on("click", "#kt_datatable_promotion .btn_change_online", (e) => {
        const id = e.target.getAttribute('data-id');
        // updatePromotionStatus(id)
    });

    $(document).on("click", "#kt_datatable_promotion .edit_btn", (e) => {
        let id = e.target.getAttribute('data-id')
        router.push({ name: 'promotion-detail', params: { id: id } })
    });

    $(document).on("click", "#kt_datatable_promotion .delete_btn", (e) => {
        const id = e.target.getAttribute('data-id')
        // deletePromotion(id)
    });
}

</script>

<style scoped>
.light-danger {
  color: #f1416c;
  border-color: #fff5f8;
  background-color: #fff5f8;
  font-size: .925rem;
  border-radius: 0.325rem;
  padding: 5px 10px;
}

.light-primary {
  color: #0b3d87;
  border-color: #f1faff;
  background-color: #f1faff;
  font-size: .925rem;
  border-radius: 0.325rem;
  padding: 5px 10px;
}
</style>